import { render, staticRenderFns } from "./MonitoringReportTable.vue?vue&type=template&id=979d93d6"
import script from "./MonitoringReportTable.vue?vue&type=script&lang=js"
export * from "./MonitoringReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports